module.exports = __webpack_public_path__ + "images/emoji/microscope.644f93c968b40669c74d.png";